function mapCheck() {
    const url = utils.url.getUrlParams();
    const mapCheck = url.has('map');

    return mapCheck
}

var commonDoWorkout = {
    toggleView = async (isListView) => {
        const filterList = document.getElementById('facility-filter-list-content');
        const mapContent = document.getElementById('map');
        const listViewBtn = document.getElementById('list-view-btn');
        const mapViewBtn = document.getElementById('map-view-btn');
        const urlParams = new URLSearchParams(window.location.search);

        if (!listViewBtn || !mapViewBtn) {
            return;
        }

        if (isListView) {
            utils.common.showElement(filterList);
            filterList.setAttribute('aria-hidden', 'false')
            mapViewBtn.disabled = false;

            utils.common.hideElement(mapContent);

            listViewBtn.setAttribute('aria-pressed', 'true');
            listViewBtn.classList.replace('btn-ghost', 'btn-secondary');
            mapViewBtn.setAttribute('aria-pressed', 'false');
            mapViewBtn.classList.replace('btn-secondary', 'btn-ghost');
            
            // show-more-facilities.js
            window.showButtonFunction(false) 
            // Remove 'map=true' from URL parameters
            urlParams.delete('map');
        } else {
            utils.common.showElement(mapContent);
            await findExerciseLocationMap.initMapSetup();

            utils.common.hideElement(filterList)
            filterList.setAttribute('aria-hidden', 'true')
            utils.common.showElement(mapContent)

            listViewBtn.setAttribute('aria-pressed', 'false');
            listViewBtn.classList.replace('btn-secondary', 'btn-ghost');
            mapViewBtn.setAttribute('aria-pressed', 'true');
            mapViewBtn.classList.replace('btn-ghost', 'btn-secondary');

            // show-more-facilities.js
            window.showButtonFunction(true) 
            
            // Add 'map=true' to URL parameters
            urlParams.set('map', 'true');
            handleUrlParameters()
        }

        // Update the URL without reloading the page
        const newUrl = utils.url.decodedUrl(urlParams);;
        window.history.replaceState({}, '', newUrl);

    },

    checkIfMapView = () => {
        const checkMapView = mapCheck();

        if (checkMapView) {
            toggleView(false);
        } else {
            toggleView(true);
        };
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('facility-filter-list-content') && document.getElementById('map')) {
        commonDoWorkout.checkIfMapView();
    }
});
